export const languageUtils = {

  languages: ['es', 'en'],

  getLanguage: () => {

    let path = typeof window !== 'undefined' ? window.location.pathname : '/en';
    let isSpanish = path.split('/').find(part => part === 'es');

    return isSpanish==='es' ? 'es' : 'en';
  },

  toggleLanguage: () => {
    const lang = languageUtils.getLanguage()
    let newLanguage;
    if (lang === 'es') newLanguage = 'en';
    if (lang === 'en') newLanguage = 'es';
    return newLanguage;
  }
}
